import type { SVGProps } from 'react';
const SvgAllOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#all_out_svg__a)">
      <path
        fill="currentColor"
        d="m16.21 4.16 4 4v-4h-4Zm4 12-4 4h4v-4Zm-12 4-4-4v4h4Zm-4-12 4-4h-4v4Zm12.95-.95a7.007 7.007 0 0 0-9.9 0 7.007 7.007 0 0 0 0 9.9 7.007 7.007 0 0 0 9.9 0c2.73-2.73 2.73-7.16 0-9.9Zm-1.1 8.8a5.438 5.438 0 0 1-7.7 0 5.438 5.438 0 0 1 0-7.7 5.438 5.438 0 0 1 7.7 0 5.438 5.438 0 0 1 0 7.7Z"
      />
    </g>
    <defs>
      <clipPath id="all_out_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAllOut;
